export { Popup } from '@sberdevices/plasma-core';
export type { PopupProps } from '@sberdevices/plasma-core';
